<div class="d-flex align-items-center">
  <a mat-button *ngIf="showMenu" (click)="menuClicked.emit()">
    <mat-icon class="m-0">menu</mat-icon>
  </a>
  <div class="breadcrumb-container">
    <div
      class="root cursor-pointer p-0"
      (click)="onRootIconClicked()"
      *ngIf="nodes.length > 0 && root?.title && root?.icon; else showHomeLink"
    >
      <h1 class="d-flex m-0 align-items-center">
        <mat-icon class="d-flex align-items-center">{{ root?.icon }}</mat-icon>
        {{ root?.title }}
      </h1>
    </div>
    <ng-template #showHomeLink>
      <a mat-button class="root" (click)="onRootIconClicked()" *ngIf="nodes.length > 0">
        <mat-icon class="m-0">home</mat-icon>
      </a>
    </ng-template>
    <span *ngFor="let node of nodes; let i = index">
      <mat-icon class="v-middle">keyboard_arrow_right</mat-icon>
      <a class="breadcrumb-item" mat-button (click)="onNodeClicked(node, i)">
        <mat-icon *ngIf="node?.icon">{{ node.icon }}</mat-icon>
        {{ node.name }}</a
      >
    </span>
  </div>
</div>
